import { ConfirmModal } from 'components/modal/ConfirmModal';
import { CustomTable } from 'components/table/style';
import { iconSort } from 'components/table/utlil';
import { Row, Table, TextInput, closeModal, updateQueryStateTable } from 'enable-ui';

import { useAuthStore, userProfileSelector } from 'modules/auth/core';
import { MODAL_KEY } from 'modules/auth/core/modal-key';

import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';

import { TABLE_KEY } from 'constants/table';

import { getAdminsColumns } from '../core/columns';
import { useAdminsController } from '../core/controller/admin-user';

const AdminUserPage = () => {
  const {
    total,
    queryState,
    admins,
    onDelete,
    onClickAction,
    onClickRow,
    searchValue,
    onChangeSearchValue,
  } = useAdminsController();
  const userProfile = useAuthStore(userProfileSelector);

  const isSuperAdmin = userProfile?.isSuperAdmin || false;

  const columns = getAdminsColumns(onClickAction, isSuperAdmin);

  if (!queryState) {
    return null;
  }

  return (
    <Row direction="column">
      <TextInput
        containerStyle={{
          marginBottom: 16,
        }}
        value={searchValue.value}
        placeholder="Search by name, phone"
        onChange={onChangeSearchValue}
        inputStyle={{
          backgroundColor: 'transparent',
          width: '40%',
        }}
        prefix={<SearchIcon />}
      />

      <CustomTable>
        <Table
          columns={columns}
          dataSource={admins}
          total={total.value}
          tableKey={TABLE_KEY.ADMINS}
          queryState={{
            ...queryState,
            orderBy:
              queryState.orderBy === 'createdAt' && queryState.orderDirection === 'DESC'
                ? 'name'
                : queryState.orderBy,
            orderDirection:
              queryState.orderBy === 'createdAt' && queryState.orderDirection === 'DESC'
                ? 'ASC'
                : queryState.orderDirection,
          }}
          updateQueryState={updateQueryStateTable}
          onClickRow={onClickRow}
          headerConfigs={{
            iconSort,
          }}
        />
      </CustomTable>

      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_ADMIN}
        content={
          'All the stored data of this admin user will be deleted. This action can not undo.'
        }
        header={`Delete admin user`}
        onCancel={() => closeModal(MODAL_KEY.DELETE_ADMIN)}
        onSubmit={onDelete}
      />
    </Row>
  );
};

export default AdminUserPage;
